module.exports = __webpack_public_path__ + "static/Houdini-4f2f760b4a93c8192ba3ed11b2ea8dce.png";